<template>
  <div class="MeinServiceContainer">
    <Header name="Vorhandenes Profil laden"/>
    <div class="cursor-pointer header" @click="$emit('GoBackToProfil')">
      <SVGIcon size="small" name="arrow_back_blue" class="selfAlignCenter"/>
      <div class="headerText colorBlue">zurück</div>
    </div>
    <!-- <div class="selfAlignCenter">Ihr Profil anmelden</div> -->
    <div class="content" style="margin-top:45px;">
      <!-- <p
        class="colorDarkGrey fontsize16 marginbottom15"
      >Sie müssen sich nicht zwingend anmelden. Sie können Routen und Benachrichtigungen auch als Gast auf diesem Gerät nutzen.</p>-->
      <input
        ref="pin"
        :bind="pin"
        @input="pin = $event.target.value"
        :value="pin"
        type="text"
        name="pin"
        id="pin"
        placeholder="Ihre Profilnummer"
        class="colorBlue borderBlue borderBottom marginbottom15 fontweight600"
        @click="focus('pin')"
      >
      <input
        ref="passwort"
        :bind="passwort"
        @input="passwort = $event.target.value"
        :value="passwort"
        type="password"
        name="passwort"
        id="passwort"
        placeholder="Ihr Passwort"
        class="colorBlue borderBlue borderBottom fontweight600"
        @click="focus('passwort')"
      >
      <div
        style="margin:45px 50px 34px 50px;"
        class="colorBlue borderBlue borderWidth1 borderStyleSolid borderRadius30 padding5 textcenter cursor-pointer"
        @click="serviceLaden()"
      >
        <!-- Service laden -->
        Profil laden
      </div>

      <p class="colorRed fontsize16 marginbottom15">Wichtig:</p>
      <p class="colorLightGrey fontsize16 marginbottom15">Mit dem Laden Ihres gespeicherten Profils, werden Ihre aktuellen Einstellungen überschrieben</p>
      <!-- <div class="displayflex flexbetween" v-if="checkIfErstellen()">
                <div class="width100">
                    <div class="borderBottomWidth2 borderBottomStyleSolid borderDarkGrey height50"></div>
                </div>
                <div class="margin0_20">oder</div>
                <div class="width100">
                    <div class="borderBottomWidth2 borderBottomStyleSolid borderDarkGrey height50"></div>
                </div>
            </div>

            <div
                class="colorBlue borderBlue borderWidth1 borderStyleSolid borderRadius30 padding10 textcenter cursor-pointer margin20_40"
                @click="$emit('GoToServiceErstellen')"
                v-if="checkIfErstellen()"
            >
                Profil speichern
      </div>-->
    </div>
  </div>
</template>

<script>
import Header from "./../CoreComponents/Header.vue";

export default {
  name: "MeinServiceAnmelden",
  components: { Header },
  data: function() {
    return {
      pin: null,
      passwort: null
    };
  },
  mounted() {},
  methods: {
    focus(focusRef) {
      this.$refs[focusRef].focus();
    },
    checkIfErstellen() {
      if (this.routen.length !== 0 || this.kartenansicht) return true;
      else return false;
    },
    serviceLaden() {
      if (!this.pin) {
        this.$store.dispatch(
          "sendNotificationError",
          "Bitte geben Sie Ihre Profilnummer ein"
        );
        return;
      }

      if (!this.passwort) {
        this.$store.dispatch(
          "sendNotificationError",
          "Bitte geben Sie Ihr Passwort ein"
        );
        return;
      }

      this.$store.dispatch("serviceLaden", {
        passwort: this.passwort,
        pin: this.pin
      });
    }
  },
  computed: {
    routen() {
      return this.$store.state.routen;
    },
    kartenansicht() {
      return this.$store.state.kartenansicht;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  display: flex;
  margin-bottom: 15px;
}

.headerText {
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-left: 30px;
}
</style>
